<template>
  <aside :class="classes.Description">
    <DSIcon
      v-if="expanded"
      :class="classes.DescriptionIcon"
      icon="info"
      size="md"
      aria-hidden="true"
      data-cy="ds-light-box__description-info"
    />
    <p
      v-if="expanded"
      data-cy="ds-light-box__description"
    >
      {{ description }}
    </p>
    <DSButton
      variant="ghost"
      size="sm"
      :prefix-icon="expanded ? 'cross' : 'info'"
      :aria-label="expanded ? LIGHT_BOX_I18N.hideDescription : LIGHT_BOX_I18N.showDescription"
      :aria-expanded="expanded"
      data-cy="ds-light-box__toggle-description"
      @click="onToggleDescriptionClick"
    />
  </aside>
</template>

<script setup lang="ts">
import { ref } from "vue";
import DSButton from "@/src/design_system/button_and_controls/button/components/DSButton.vue";
import DSIcon from "@/src/design_system/primitives/icon/components/DSIcon.vue";
import { DS_LIGHT_BOX_CLASSES as classes } from "../constants/classes";

defineProps<{ description: string }>();
const expanded = ref(true);
const LIGHT_BOX_I18N = window.I18n.designSystem.lightBox;
const onToggleDescriptionClick = () => {
  expanded.value = !expanded.value;
};
</script>
